import {
  CONTENT_TYPE,
  IHeroWithVideo as IContentfulHeroWithVideo,
} from 'marketing-site/@types/generated/contentful'
import { renderTransformedComponent } from 'marketing-site/lib/transformedComponents'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import {
  HeroWithVideo,
  IProps as IHeroWithVideo,
} from 'marketing-site/src/library/components/HeroWithVideo'
import { IBrand, useBrand } from 'marketing-site/src/library/providers/brandProvider'
import React from 'react'

export const ContentfulHeroWithVideo = (data: IContentfulHeroWithVideo) => {
  const brand = useBrand()
  return (
    <EntryMarker entry={data}>
      {() => <HeroWithVideo {...transformHeroWithVideo(data, brand)} />}
    </EntryMarker>
  )
}

export function transformHeroWithVideo(
  data: IContentfulHeroWithVideo,
  brand: IBrand,
): IHeroWithVideo {
  const videoContentTypeId = data.fields.video.sys.contentType.sys.id as CONTENT_TYPE
  const videoEntryId = data.fields.video

  return {
    ...data.fields,
    posterImage: data.fields.posterImage.fields.file.url,
    renderModalContent: () =>
      renderTransformedComponent(videoContentTypeId, videoEntryId, undefined, brand),
    cta: data.fields.cta,
    secondaryCta: data.fields.secondaryCta,
  }
}
